import actions from '@/requests/constants';
import withDraft from '@/utils/draftHelper';
import { fetchWorkflowState, showWorkflowErrorState, showWorkflowState } from './state';

const showWorkflowForRequest = withDraft((draft, action) => showWorkflowState(draft, action));

export default {
  [actions.FETCH_WORKFLOW_FOR_REQUEST]: fetchWorkflowState,
  [actions.SHOW_WORKFLOW_FOR_REQUEST]: showWorkflowForRequest,
  [actions.SHOW_WORKFLOW_REQUEST_ERROR]: showWorkflowErrorState,
};
